export const getTimeToLearn = (timeToLearn: number | null | undefined) =>
  typeof timeToLearn === "number" && timeToLearn >= 90 ? timeToLearn : 90;
